// extracted by mini-css-extract-plugin
export default {"scrollContainer":"ProfileListSection_scrollContainer__Ig95V"};